import React from "react";
import DataTable, { TableColumn, TableProps } from "react-data-table-component";

type Props = TableProps<any> & {
    columns: TableColumn<unknown>[]
    data: unknown[]
    isPagination?: boolean
}

// Define color variables
const colors = {
    tableBackground: '#F5F5F5',
    borderColor: '#ADADA7',
    headerBackground: '#F3DB91',
    headerTextColor: '#666',
    rowBackground: '#FFFFFF',
    alternateRowBackground: '#FFFFFF', // If you have an actual alternate color, you can change this
    rowHoverBackground: '#FFF3DD',
    paginationBackground: '#FFFFFF',
};

export const tableCustomStyles = {
    table: {
        style: {
            backgroundColor: colors.tableBackground,
            borderTop: `1px solid ${colors.borderColor}`,
            borderLeft: `1px solid ${colors.borderColor}`,
            borderRight: `1px solid ${colors.borderColor}`,
            borderBottom: `1px solid ${colors.borderColor}`,
            borderRadius: '6px',
            overflow: 'hidden',
            width: '100%',
        },
    },
    headRow: {
        style: {
            fontWeight: '700',
            borderBottom: 'none', // Remove the default border-bottom for the head row
            color: colors.headerTextColor,
            backgroundColor: colors.headerBackground,
            fontSize: '18px',
        },
    },
    headCells: {
        style: {
            borderRight: `1px solid ${colors.borderColor}`, // Border between header cells
            '&:last-child': {
                borderRight: 'none', // Remove the right border from the last header cell
            },
            borderBottom: `1px solid ${colors.borderColor}`, // Added border bottom
        },
    },
    cells: {
        style: {
            borderRight: `1px solid ${colors.borderColor}`, // Border between cells
            '&:last-child': {
                borderRight: 'none', // Remove the right border from the last cell
            },
            // borderBottom: `1px solid ${colors.borderColor}`, // Not Needed as added border bottom above
        },
    },
    rows: {
        style: {
            backgroundColor: colors.rowBackground, // Row background color
            '&:nth-child(2n)': {
                backgroundColor: colors.alternateRowBackground, // Alternate row background color
            },
            borderBottom: 'none', // Remove the default border-bottom for rows
            '&:hover': {
                backgroundColor: colors.rowHoverBackground, // Row hover background color
            },
            fontSize: '15px',
            color: '#666',
            wordSpace: 'break-word',
            whiteSpace: 'pre-wrap',
        },
    },
    pagination: {
        style: {
            backgroundColor: colors.paginationBackground,
        },
    },
};

const Table = ({ columns, data, isPagination = true, ...props }: Props) => {
    const sortIcon = `<svg width="24" height="25" style="opacity: 1;" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.14539 4.35547L5.98039 4.84747L4.52839 8.85547H4.50439V8.90272L3.80089 10.8475L3.75439 10.9645V11.8555H5.25439V11.2225L5.55889 10.3555H7.94989L8.25439 11.2225V11.8555H9.75439V10.9645L9.70714 10.8475L9.00439 8.90197V8.85547H8.98189L7.52689 4.84747L7.36489 4.35547H6.14314H6.14539ZM16.5044 4.35547V18.3715L14.5589 16.426L13.5044 17.4805L16.7144 20.7152L17.2544 21.2305L17.7944 20.7145L21.0044 17.4805L19.9499 16.426L18.0044 18.3707V4.35547H16.5044ZM6.75439 7.09747L7.38739 8.85547H6.12139L6.75439 7.09747ZM3.75439 13.3555V14.8555H7.92664L3.96439 18.8155L3.75439 19.051V20.8555H9.75439V19.3555H5.58214L9.54364 15.3955L9.75364 15.16V13.3555H3.75439Z" fill="#666"/>
  </svg>`

    const paginationOptions = {
        noRowsPerPage: true,
        selectAllRowsItem: false,
    }

    return (
        <DataTable
            columns={columns}
            data={data}
            customStyles={tableCustomStyles}
            className="table-auto w-full whitespace-no-wrap bg-white table-striped relative centered-table"
            paginationServer
            pagination={isPagination}
            sortIcon={<div dangerouslySetInnerHTML={{ __html: sortIcon }} />}
            paginationComponentOptions={paginationOptions}
            {...props}
        />
    )
}

export default Table;